import TimePicBox from './timebox.vue';
export default TimePicBox;


// WEBPACK FOOTER //
// ./src/components/timebox/index.js